<template>
  <div id="app">
    <loader @defaults-fetched="loaded = $event" />
    <navigation />
    <splash />
    <about />
    <services />
    <skills />
    <experience-vue />
    <portfolio />
    <quote />
    <app-footer />
  </div>
</template>

<script>
import Navigation from "@/components/master/nav.vue";
import Loader from "@/components/master/loader.vue";
import AppFooter from "@/components/master/footer.vue";
// Other pages
import Splash from "@/components/Splash.vue";
import About from "@/components/About.vue";
import Services from "@/components/Services.vue";
import Skills from "@/components/Skills.vue";
import ExperienceVue from "@/components/Experience.vue";
import Portfolio from "@/components/Portfolio/Portfolio.vue";
import Quote from "@/components/Quote.vue";
// require("./models/experience.js");


export default {
  data() {
    return {
      loaded: false
    };
  },

  components: {
    Navigation,
    Loader,
    AppFooter,
    // Others
    Splash,
    About,
    Services,
    Skills,
    ExperienceVue,
    Portfolio,
    Quote
  },

  watch: {
    loaded() {
      this.loaded == true
        ? $(".section-loader").fadeOut("slow")
        : $(".section-loader").fadeIn("slow");
    }
  },

  methods: {
    //
  },

  created() {
    // this.mixin_defaults();
    // this.mixin_set_skills();
    // this.mixin_set_categories();
    // this.mixin_set_stacks();
    // this.mixin_set_workExp();
    // this.updateDisplayImageUrl();
    // this.updateCVUrl()
  }
};
</script>
